{
  "version": 1,
  "asset_id": "53ecbb2d-b1c7-413f-a0cf-d62c21286d32",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/53ecbb2d-b1c7-413f-a0cf-d62c21286d32/destination-roofing-owner-sales-team-crystal-river-fl-960w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/53ecbb2d-b1c7-413f-a0cf-d62c21286d32/destination-roofing-owner-sales-team-crystal-river-fl-960w.webp",
  "original_filename": "destination-roofing-owner-sales-team-crystal-river-fl-960w.webp",
  "size": 54406,
  "content_type": "image/webp",
  "created_at": "2026-07-21T15:42:45Z"
}
